import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { readConveyor, unloadConveyor } from "../../modules/conveyor/conveyorSlice";
import ConveyorViewer from "./ConveyorViewer";
import { setOriginalConveyor } from "../../modules/conveyor/conveyorWriteSlice";
import { removeConveyor } from "../../modules/conveyor/conveyorAPI";
import ActionButtons from "./ActionButtons";





const ConveyorViewerContainer = () => {
    const { conveyorId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // const { conveyor, error, loading, user } = useSelector(({ conveyor, loading, user }) => ({
    //     conveyor: conveyor.conveyor,
    //     error: conveyor.error,
    //     loading: loading['conveyor/READ_CONVEYOR'],
    //     user: user.user,
    // }));

    const conveyor = useSelector(state => state.conveyor.conveyor);
    const error = useSelector(state => state.conveyor.error);
    const loading = useSelector(state => state.loading);
    const user = useSelector(state => state.user.user);

    useEffect(() => {
        dispatch(readConveyor(conveyorId));

        return () => {
            dispatch(unloadConveyor());
        }
    }, [conveyorId, dispatch]);

    const onEdit = () => {
        // 스토어의 conveyor를 가져와서 스토어의 write에 쓴 후 ConveyorEditorPage로 이동한다.
        dispatch(setOriginalConveyor(conveyor))
        navigate('/write/conveyor');
    }

    const onRemove = async () => {
        try {
            await removeConveyor(conveyorId);
            navigate(-1);
        } catch (error) {
            console.error(error);
        }
    }

    const ownConveyor = (user && user._id) === (conveyor && conveyor.user._id);

    return (
        <ConveyorViewer conveyor={conveyor} loading={!loading} error={error} actionButtons={ ownConveyor && <ActionButtons onEdit={onEdit} onRemove={onRemove} /> } />
    );

};

export default ConveyorViewerContainer;